import {Directive, ElementRef, Renderer2, AfterViewInit, HostListener} from '@angular/core';

import {filter} from "rxjs";
import {HeroStyleService} from "../../service/hero-style.service";

@Directive({
  selector: 'textarea.hero-textarea-adjust',
  standalone: true,
})
export class HeroTextareaAdjustDirective {
  constructor(
    private el: ElementRef<HTMLTextAreaElement>,
    private renderer: Renderer2,
    private styleServ: HeroStyleService
  ) {
  }

  ngAfterViewInit(): void {
    this.styleServ.styleLoaded$
      .pipe(filter(v => !!v))
      .subscribe((v) => {
        this.adjustHeight();
      });
  }

  @HostListener('input')
  onInput(): void {
    this.adjustHeight();
  }

  private adjustHeight(): void {
    // Reset height to auto to get accurate scrollHeight
    this.renderer.setStyle(this.el.nativeElement, 'height', 'auto');
    // Set height to scrollHeight, adding padding for consistency
    const scrollHeight = this.el.nativeElement.scrollHeight;
    this.renderer.setStyle(this.el.nativeElement, 'height', `${scrollHeight}px`);
    // Ensure overflow-y is hidden to prevent scrollbar
    this.renderer.setStyle(this.el.nativeElement, 'overflow-y', 'hidden');
  }
}
